import React from 'react';
import { useNavigate } from 'react-router-dom';
import { soundManager } from '../utils/SoundManager';
import everythingTrainers from '../data/trainers/EverythingTrainers';
import './EverythingTrainers.css';

const EverythingTrainers = () => {
    const navigate = useNavigate();

    // Get everything trainers from the trainers data file
    const everythingTrainersData = Object.values(everythingTrainers);

    // Handle trainer selection
    const handleTrainerSelect = (trainer) => {
        console.log('Everything trainer selected:', trainer);

        // 🎵 PLAY EVERYTHING TRAINER SELECTION SOUND
        soundManager.playSound('bodyweightSet', 0.7);

        // Navigate to the everything trainer page
        navigate(`/everything-trainer/${trainer.id}`);
    };

    // Handle back to train categories
    const handleBackToCategories = () => {
        soundManager.playButtonSound();
        navigate('/train-categories');
    };

    return (
        <div className="everything-trainers-container">
            {/* Purple pulsating background */}
            <div className="purple-pulsing-background"></div>

            <header className="everything-trainers-header">
                <button
                    className="back-to-categories-button"
                    onClick={handleBackToCategories}
                >
                    ← Back to Categories
                </button>

                <div className="header-content">
                    <h1>Everything All Moves Trainers</h1>
                    <p>Master coaches for comprehensive fitness training</p>
                    <div className="category-stats">
                        <span className="stat-badge">6 Complete Masters</span>
                        <span className="stat-badge">36 Total Programs</span>
                        <span className="stat-badge">All-in-One Training</span>
                    </div>
                </div>
            </header>

            <div className="everything-trainers-grid">
                {everythingTrainersData.map((trainer) => (
                    <div
                        key={trainer.id}
                        className="everything-trainer-card"
                        onClick={() => handleTrainerSelect(trainer)}
                    >
                        <div className="everything-trainer-image-section">
                            <div
                                className="everything-trainer-image"
                                style={{
                                    backgroundImage: `url(${trainer.image})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center'
                                }}
                            >
                                <div className="experience-badge">
                                    {trainer.experience}
                                </div>
                            </div>
                        </div>

                        <div className="everything-trainer-info-section">
                            <h3 className="everything-trainer-name">{trainer.name}</h3>
                            <h4 className="everything-trainer-specialization">{trainer.specialization}</h4>
                            <p className="everything-trainer-description">{trainer.intro?.substring(0, 120)}...</p>

                            <div className="everything-trainer-details">
                                <div className="detail-item">
                                    <span className="detail-icon">🌟</span>
                                    <span className="detail-text">{trainer.category} specialist</span>
                                </div>
                                <div className="detail-item">
                                    <span className="detail-icon">📋</span>
                                    <span className="detail-text">{trainer.programs?.length || 6} Programs</span>
                                </div>
                            </div>

                            <div className="everything-trainer-action">
                                <button className="select-everything-trainer-button">
                                    Complete Programs
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <footer className="everything-trainers-footer">
                <div className="everything-info">
                    <h3>🌟 Complete Fitness Mastery</h3>
                    <div className="everything-benefits-grid">
                        <div className="everything-benefit-item">
                            <span className="benefit-icon">🎯</span>
                            <div>
                                <strong>All-in-One Training</strong>
                                <p>Master every aspect of fitness in one comprehensive program</p>
                            </div>
                        </div>
                        <div className="everything-benefit-item">
                            <span className="benefit-icon">⚡</span>
                            <div>
                                <strong>Complete Development</strong>
                                <p>Strength, cardio, flexibility, and skill training combined</p>
                            </div>
                        </div>
                        <div className="everything-benefit-item">
                            <span className="benefit-icon">🌟</span>
                            <div>
                                <strong>Total Transformation</strong>
                                <p>Achieve peak physical condition with integrated methods</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default EverythingTrainers;